import "./instructions_list.scss";

import { injectIntl, defineMessages } from "react-intl";
import PropTypes from "prop-types";

import Icon from "common/core/icon";
import { DOCUMENT_ICON } from "constants/icon";

const instructionMessages = defineMessages({
  notarization: {
    id: "e3abb184-c366-444b-8c3e-58341b9de309",
    description: "instructionsNotarization",
    defaultMessage: "Notarization Required",
  },
  proofing: {
    id: "e5e75b72-f9fa-4eab-a96f-309cb67f92d1",
    description: "instructionsVerificationOfFact",
    defaultMessage: "Verification Of Fact Required",
  },
  annotation: {
    id: "8e46109e-281d-474f-9ea2-d941ea9fc15f",
    description: "instructionsAnnotate",
    defaultMessage: "Signer Can Fill In Document",
  },
  witness: {
    id: "40b375b1-70c5-4eee-9565-12841ba7e4e1",
    description: "instructionsWitness",
    defaultMessage: "Additional Witness Required",
  },
  inMeeting: {
    id: "66593a6e-2a8f-4044-880c-a6f2ed0157fb",
    description: "instructionsInMeeting",
    defaultMessage: "Signing Requires Meeting",
  },
  wetSign: {
    id: "aa7a9416-a16a-4698-9ac1-3eadda58df88",
    description: "instructionsWetSign",
    defaultMessage: "Requires Wet Signing",
  },
  wetSignLine: {
    id: "3cb8572c-843d-4429-a8a6-1ef9e391b11a",
    description: "instructionsESign",
    defaultMessage: "Requires eSign",
  },
  vault: {
    id: "82160d7c-1828-4343-b67b-2c833a306984",
    description: "instructionsVault",
    defaultMessage: "Store in eVault",
  },
  authEsign: {
    id: "4c96e96f-2a1f-4475-aca0-2b220b1f59cb",
    defaultMessage: "Authenticated eSign",
  },
});

function getMessageFromIconName(iconName) {
  switch (iconName) {
    case DOCUMENT_ICON.PROOFING:
      return instructionMessages.proofing;
    case DOCUMENT_ICON.ANNOTATE:
      return instructionMessages.annotation;
    case DOCUMENT_ICON.WITNESS:
      return instructionMessages.witness;
    case DOCUMENT_ICON.IN_MEETING:
      return instructionMessages.inMeeting;
    case DOCUMENT_ICON.WET_SIGN:
      return instructionMessages.wetSign;
    case DOCUMENT_ICON.WET_SIGN_LINE:
      return instructionMessages.wetSignLine;
    case DOCUMENT_ICON.SECURE:
      return instructionMessages.vault;
    case DOCUMENT_ICON.AUTH_ESIGN:
      return instructionMessages.authEsign;
    default:
      return instructionMessages.notarization;
  }
}

function InstructionsList({ iconName, intl }) {
  const cx = "DocumentUploader--InstructionsList";
  const message = getMessageFromIconName(iconName);

  return (
    <ul className={cx}>
      <li className={`${cx}--Item`}>
        <Icon name={iconName} className={`${cx}--Icon`} />
        <div className={`${cx}--Message`}>{intl.formatMessage(message)}</div>
      </li>
    </ul>
  );
}

export default injectIntl(InstructionsList);

InstructionsList.propTypes = {
  iconName: PropTypes.string.isRequired,
};
